import { useEffect, useState } from 'react';

type prefixType = 'moz' | 'ms' | 'o' | 'webkit';
const browserPrefixes = ['moz', 'ms', 'o', 'webkit'];

function getHiddenPropertyName(prefix: string) {
  return prefix ? prefix + 'Hidden' : 'hidden';
}

function getVisibilityEvent(prefix: prefixType) {
  return (prefix ? prefix : '') + 'visibilitychange';
}

function getBrowserPrefix() {
  if (typeof window !== 'undefined') {
    for (let i = 0; i < browserPrefixes.length; i++) {
      if (getHiddenPropertyName(browserPrefixes[i]) in document) {
        return browserPrefixes[i];
      }
    }
  }

  return '';
}

const browserPrefix: string = getBrowserPrefix();

export function useWindowFocus() {
  const [isWindowFocused, setWindowFocused] = useState(true);

  const handleFocus = () => {
    setWindowFocused(true);
    if (process.env['NODE_ENV'] === 'development') {
      console.log(`the page is now focused: ${new Date()}`);
    }
  };

  const handleBlur = () => {
    setWindowFocused(false);
    if (process.env['NODE_ENV'] === 'development') {
      console.log(`the page is now unfocused: ${new Date()}`);
    }
  };

  function handleVisibilityChange() {
    if (document[getHiddenPropertyName(browserPrefix) as keyof Document]) {
      handleBlur();
    } else {
      handleFocus();
    }
  }

  useEffect(() => {
    window.addEventListener(
      getVisibilityEvent(browserPrefix as prefixType),
      handleVisibilityChange,
      false
    );

    return () => {
      window.removeEventListener(
        getVisibilityEvent(browserPrefix as prefixType),
        handleVisibilityChange,
        false
      );
    };
  }, []);

  return () => isWindowFocused;
}
